module.exports = __webpack_public_path__ + "img/hcl-certified.38487821.png";